export default __webpack_public_path__ + "static/Marque-de-Riscal-49fb27ba15cab794e87616f3b9947447.jpg";